import { useContext } from "react";
import { CurrentUserContext } from "./CurrentUserContext";

export function useCurrentUser() {
  return useContext(CurrentUserContext);
}
